import React from 'react'
import { useHistory } from 'react-router-dom'
import CompaniesList from './CompaniesList'
import CompanyGroupsList from './CompanyGroupsList'

export function CompaniesPage({ onSelectCompany, activeTab = 'empresas' }) {
  const history = useHistory()

  return (
    <>
      <div className="page-header">
        <h1 className="page-title">Empresas</h1>
        <p className="page-subtitle">
          Gestión de empresas registradas y grupos empresariales
        </p>
      </div>

      <div className="mode-tabs companies-page-tabs">
        <button
          type="button"
          className={`mode-tab ${activeTab === 'empresas' ? 'active' : ''}`}
          onClick={() => history.push('/empresas')}
        >
          Empresas
        </button>
        <button
          type="button"
          className={`mode-tab ${activeTab === 'grupos' ? 'active' : ''}`}
          onClick={() => history.push('/empresas/grupos')}
        >
          Grupos Empresariales
        </button>
      </div>

      {activeTab === 'grupos' ? (
        <CompanyGroupsList embedded />
      ) : (
        <CompaniesList onSelectCompany={onSelectCompany} embedded />
      )}
    </>
  )
}

export default CompaniesPage
